export enum InstructorUsageType {
    All = 0,
    Individual = 1,
    Groups = 2
}